import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env, isSupabaseConfigured } from "./env";

/**
 * Browser Supabase client. Uses the ANON key only - all privileged access is
 * enforced by Row Level Security + edge functions on the server
 * (docs/SECURITY.md sec 1-2). The service_role key is NEVER used in the browser.
 *
 * Returns null until env vars are set, so the app can run on mock data during
 * early development (Phase 0-2 before a Supabase project exists).
 */
export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
